module.exports = __webpack_public_path__ + "assets/img/Deep.291b869d.svg";